import { createFileRoute } from '@tanstack/react-router';

import { AdminPeoplePage } from '@/components/admin/sport/people-page';
import { adminHead } from '@/lib/seo';
import { adminListPeopleFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/people')({
    component: PeopleRoute,
    head: () => adminHead('שחקנים', '/admin/sport/people'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListPeopleFn({ data: { limit: 50 } }),
});

function PeopleRoute() {
    return <AdminPeoplePage initial={Route.useLoaderData()} />;
}
